import * as React from "react";
const Svg18UpRating = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M13 12.5h1.5V14H13zm0-2.5h1.5v1.5H13z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3v18h18V3zM10 15H8.5v-4.5H7V9h3v6zm6-1c0 .55-.45 1-1 1h-2.5c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1H15c.55 0 1 .45 1 1v4z",
  fill: "currentColor"
}));
export default Svg18UpRating;